<template>
  <hm-content title>
    <div class="create">
      <img
        src="https://imgcdn.hemiao100.com/ThemePictures/yingxiaohuodong.png"
        alt
      />
    </div>
    <!-- <div class="flex flex-wrap flex-between"> -->
    <template class="flex flex-center">
      <div class="flex flex-wrap">
        <div
          v-for="(v, i) in list"
          :key="i"
          @click="createdGame(v)"
        >
          <template v-if="v.show">
          <div class="grid-content bg-purple">
          <div style="width:250px;height:138px">
            <img style="width:100%;height:100%" :src="v.img" alt />
          </div>

          <div class="flex flex-between">
            <el-tooltip placement="bottom" :content="v.content">
              <span class="acttitle" style="flex:1">{{ v.content }}</span>
            </el-tooltip>
            <div class="add-wrapper small">
              <span class="hmicon icon-hao pointer"></span>
            </div>
          </div>
          </div>
          </template>
        </div>
      </div>
    </template>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogVisible"
    >
      <div class="flex flex-warp">
        <div class="gameImg">
          <img style="width:100%;height:100%" :src="bgimg" alt />
        </div>
        <div class="introduce flex flex-column flex-between flex-1">
          <template v-if="currentGameType === 'SpecialAct'">
            <div>
              <p>拼团首页主图</p>
              <div class="main-pic flex">
                <my-upload
                  field="file"
                  @crop-success="cropSuccess"
                  @crop-upload-success="cropUploadSuccess"
                  @crop-upload-fail="cropUploadFail"
                  v-model="show"
                  v-if="show"
                  noCircle
                  noSquare
                  :width="750"
                  :height="360"
                  :headers="{ 'X-Access-Token': $token }"
                  :params="{ fileDir: 'mallDecoration' }"
                  :url="$uploadUrl"
                  img-format="png"
                ></my-upload>
                <div class="priview" v-if="groupIndexMainPic">
                  <img :src="groupIndexMainPic" alt="主图" />
                  <div class="opreat-wrapper flex item-center flex-center">
                    <el-button type="text" @click="toggleShow"
                      >更换图片</el-button
                    >
                  </div>
                </div>
                <span class="form-tip flex-1">图片尺寸建议750x360</span>
              </div>
            </div>
            <div class="tab">
              <p>选择拼团类型</p>
              <el-radio-group
                size="small"
                v-model="activeName"
                @change="handleClick"
              >
                <el-radio-button
                  label="特价团"
                  name="SpecialAct"
                ></el-radio-button>
                <el-radio-button
                  label="抽奖团"
                  name="LotteryAct"
                ></el-radio-button>
                <el-radio-button
                  label="团长免单团"
                  name="LeaderFreeAct"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <template v-if="currentGameType === 'WheelAct'">
            <div class="tab">
              <p>选择大转盘风格</p>
              <el-radio-group
                size="small"
                v-model="activeTurntableType"
                @change="handleClickTurnTable"
              >
                <el-radio-button
                  :label="v.name"
                  :name="v.value"
                  v-for="(v, i) in wheelTypeList"
                  :key="i"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <template v-if="currentGameType === 'LuckyCharm'">
            <div class="tab">
              <el-radio-group
                size="small"
                v-model="activeLuckyCharm"
                @change="handleClickLuckyCharm"
              >
                <el-radio-button
                  :label="v.name"
                  :name="v.value"
                  v-for="(v, i) in LuckyCharmTypeList"
                  :key="i"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <template v-if="currentGameType === 'Fission'">
            <div class="tab">
              <el-radio-group
                size="small"
                v-model="activeFissionType"
                @change="handleClickFission"
              >
                <el-radio-button
                  :label="v.name"
                  :name="v.value"
                  v-for="(v, i) in fissionList"
                  :key="i"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </template>
          <div>
            <div>
              <p>玩法介绍</p>
              <span>{{ introduce }}</span>
            </div>
            <div class="mt20">
              <p>营销功能</p>
              <el-tag type="info">病毒营销</el-tag>
              <el-tag type="info">吸粉</el-tag>
              <el-tag type="info">线下引流</el-tag>
            </div>
            <div class="mt20" v-if="currentGameType==='Redeem'">
              <div>
                <div  @click="openDialogNewIntegralExchange">
                  体验新版积分商城
                  <el-switch
                    class="ml10"
                    v-model="newIntegralExchangeState"
                    active-text="开启"
                    inactive-text="关闭"
                    active-color="#13ce66"
                    active-value="open"
                    inactive-value="close"
                    :disabled="true"
                  ></el-switch>
                  
                </div>
              </div>
              <div class="tips mt20" v-if="newIntegralExchangeState === 'open'">新版积分商城，需要在店铺装修页面，选择链接"积分商城(新)"进行跳转</div>
              <div class="mt20 flex">
                <el-button size="medium" type="primary" v-if="newIntegralExchangeState === 'open'" @click="openGoodsSetting"> 
                  商品分类设置
                </el-button>
                <el-button size="medium" type="primary" v-if="newIntegralExchangeState === 'open'" @click="openRuleSetting"> 
                  规则设置
                </el-button>
              </div>
            </div>
          </div>
          <div class="mt10 flex flex-center">
            <el-button size="medium" type="primary" @click="toMyActivity"
              >我的活动</el-button
            >
            <el-button size="medium" type="primary" @click="toCreateActivity"
              >创建活动</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="体验新版积分商城"
      :visible.sync="DialogVisibleNewIntegralExchange"
      width="950px"
      @close="closeDialogNewIntegralExchange"
    >
      <div slot="newIntegralExchange">
        <span class="mr10">体验新版积分商城</span>
      </div>
      <div class="flex newIntegralExchangeContent">
        <img :src="activityList_02" class="img" alt />
        <div class="right">
          <div class="h2">体验新版积分商城</div>
          <div class="h3">• 新版积分商城支持设置商品分类，启用后原商品及活动保留</div>
          <div class="h3">• 原活动的商品分类展示在新版小程序的全部分类中，可自行更换分类</div>
          <div class="h3">• 新版积分商城，需要在店铺装修页面，选择链接"积分商城(新)"进行跳转</div>
          <div class="h3">• 开启后不支持退回旧版，请确认后再开启</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="confirmNewIntegralExchange">启用新版</el-button>
        <el-button size="small" @click="closeDialogNewIntegralExchange">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="设置积分商品分类"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoodsSettingList"
    >
      <div slot="title" class="goodsSetting">
        <span style="font-size: 18px">设置积分商品分类</span>
        <span class="form-gray ml20"
          >删除分类后所有已关联商品自动变为未设置分类</span
        >
      </div>
      <div class="table-panel flex item-center">
        <el-button type="primary" size="small" @click="addGoodsSetting"
          >添加</el-button
        >
      </div>
      <el-table
        stripe
        border
        class="mb20 mt20"
        ref="brandTable"
        :data="goodsSettingList"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="integralTypeName"
          label="积分类型名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="预览图"
          prop="previewImgPath"
          width="120"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              title="提示"
              width="200"
              trigger="hover"
              content="上传图片大小340*170，支持图片jpg、png格式"
            >
              <div slot="reference" class="flex flex-center">
                预览图
                <span>
                  <i class="el-icon-question" style="fontsize: 20px"></i>
                </span>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.previewImgPath"
              class="img"
              :src="scope.row.previewImgPath"
              alt="logo"
              :preview-src-list="[scope.row.previewImgPath]"
            />
            <div v-else>暂无图片</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="seqNum"
          label="排序"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="listShow"
          label="首页展示状态"
        >
          <template slot="header">
            <el-popover
              placement="top-start"
              title="提示"
              width="200"
              trigger="hover"
              content="首页展示开启最多6个"
            >
              <div slot="reference" class="flex flex-center">
                首页展示状态
                <span>
                  <i class="el-icon-question" style="fontsize: 20px"></i>
                </span>
              </div>
            </el-popover>
          </template>
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.indexpageShowState === 'yes'">
              显示
            </div>
            <div class="danger" v-if="scope.row.indexpageShowState === 'no'">
              隐藏
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <div class="pointer mr10" @click="editGoods(scope.row)">
                <span class="primary">编辑</span>
              </div>
              <div class="pointer mr10" @click="removeGoods(scope.row)">
                <span class="primary">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="integralTypeTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleGoodsSetting"
    >
      <div>
        <el-form
          :model="ruleFormType"
          :rules="rulesType"
          ref="ruleFormType"
          label-width="154px"
        >
          <el-form-item label="积分类型名称" prop="integralTypeName">
            <el-input
              maxlength="8"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormType.integralTypeName"
              placeholder="请输入积分类型名称(最多输入8个字)"
            ></el-input>
          </el-form-item>
          <el-form-item label="预览图" prop="previewImgPath">
            <div class="flex">
              <div
                class="flex goods-upload-btn"
                @click="addGoodsImg('', 'previewImgPath')"
                v-if="!ruleFormType.previewImgPath"
              >
                <div
                  style="margin-left: 0px"
                  class="btn flex flex-column flex-center open-file item-center"
                >
                  <div class="add-prize-img-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>添加图片</span>
                </div>
              </div>
              <div v-else class="flex item-end priviews priviews2">
                <el-image
                  class="img"
                  :src="ruleFormType.previewImgPath"
                  alt="logo"
                  :preview-src-list="[ruleFormType.previewImgPath]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button
                    type="text"
                    @click="handleRemovePrePic('previewImgPath')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="tips ml20">
                1.上传图片大小120*120，支持图片jpg、png格式<br>
                2.首页展示状态显示时必须上传图片,
              </div>
            </div>
          </el-form-item>
          <el-form-item label="排序" prop="seqNum">
            <el-input
              maxlength="6"
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormType.seqNum"
              @input="filterGt0OrFixed3('seqNum')"
              placeholder="请输入排序"
            ></el-input>
          </el-form-item>
          <el-form-item label="首页展示状态" prop="indexpageShowState">
            <el-switch
              v-model="ruleFormType.indexpageShowState"
              active-text="显示"
              inactive-text="隐藏"
              active-value="yes"
              active-color="#13ce66"
              inactive-value="no"
            ></el-switch>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="saveRuleFormType('ruleFormType')"
            >{{ integralTypeText }}</el-button
          >
          <el-button size="small" @click="closeRuleFormType">取 消</el-button>
        </span>
      </div>
    </el-dialog>
    <el-dialog
      title="设置积分商品规则"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleRuleSetting"
      width="950px"
    >
      <div slot="title" class="goodsSetting">
        <span style="font-size: 18px">设置积分商品规则</span>
      </div>
      <el-form
            :model="ruleFormRule"
            ref="ruleFormRule"
            label-width="100px"
            class="product-ruleFormRule"
          >
          <el-form-item label="预览图" prop="gameRuleBg">
            <div class="flex">
              <div
                class="flex goods-upload-btn"
                @click="addGoodsImg('', 'gameRuleBg')"
                v-if="!ruleFormRule.gameRuleBg"
              >
                <div
                  style="margin-left: 0px"
                  class="btn flex flex-column flex-center open-file item-center"
                >
                  <div class="add-prize-img-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>添加图片</span>
                </div>
              </div>
              <div v-else class="flex item-end priviews priviews2">
                <el-image
                  class="img"
                  :src="ruleFormRule.gameRuleBg"
                  alt="logo"
                  :preview-src-list="[ruleFormRule.gameRuleBg]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button
                    type="text"
                    @click="handleRemovePrePic('gameRuleBg')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="tips ml20">
                1.上传图片大小750*450，支持图片jpg、png格式<br>
                2.不上传图片则显示默认背景色,
              </div>
            </div>
          </el-form-item>
          <el-form-item label="规则查看" prop="gameRuleType">
            <el-select
              clearable
              size="small"
              v-model="ruleFormRule.gameRuleType"
              placeholder="请选择奖品类型"
            >
              <el-option label="新开页面" value="newUrl"></el-option>
              <el-option label="当前页面" value="window"></el-option>
            </el-select>
          </el-form-item>
          <!-- 加一个文本输入框 字段是 textContentZhCn   -->
          <el-form-item label="规则内容" prop="textContentZhCn">
            <el-input
              v-model="ruleFormRule.textContentZhCn"
              type="textarea"
              placeholder="请输入规则内容,比如每消费1元 = 1积分"
            />
          </el-form-item>

          <el-form-item label="活动规则说明" prop="gameRuleRemark">
            <hm-rich-editor
              v-model="ruleFormRule.gameRuleRemark"
              :html="ruleFormRule.gameRuleRemark"
            />
          </el-form-item>
      </el-form> 
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button size="small" type="primary" @click="saveRule">确 定</el-button>
        <el-button size="small" @click="closeRule">取 消</el-button>
      </span>
    </el-dialog>
    <my-upload
        field="file"
        @crop-success="cropSuccess"
        @crop-upload-success="cropUploadSuccess"
        @crop-upload-fail="cropUploadFail"
        v-model="showUploadImg"
        v-if="showUploadImg"
        noCircle
        noSquare
        :width="imgWidth"
        :height="imgHeight"
        :headers="{ 'X-Access-Token': $token }"
        :params="{ fileDir: 'goodsCenter' }"
        :url="$uploadUrl"
        img-format="png"
      ></my-upload>
  </hm-content>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import { getLoginUser } from "@/utils/auth";

export default {
  components: {
    myUpload,
    HmRichEditor
  },
  data() {
    return {
      show: false,
      groupIndexMainPic:
        "https://imgcdn.hemiao100.com/hemiaoBase/groupBuying/ps9e7e66a912f01420-c130-4ffc-83e9-52bedd7d7b9e.png",
      introduce: "",
      currentDate: new Date(),
      bgimg: "",
      activeName: "特价团",
      activeTurntableType: "传统转盘",
      activeFissionType: "企微好友裂变",
      activeLuckyCharm:"现场开奖",
      wheelType: "wheel",
      styleType:"scene",
      fissionType: "fission_person",
      textId: "",
      dialogVisible: false,
      title: "",
      currentGameType: "",
      wheelTypeList: [
        {
          name: "传统转盘",
          value: "wheel",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps5d47cd77f534d8d5-6e21-476f-98c5-61b4c05d3495.png"
        },
        {
          name: "九宫格转盘",
          value: "grid",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps9efb3fea5df5690f-b9f1-4a34-ae47-8a53ab175d50.png"
        },
        {
          name: "滚动转盘",
          value: "roll",
          bg:
            "https://imgcdn.hemiao100.com/decoration/ps8160345d748ad294-5717-4412-8f3d-dd2ac6f2b9d5.png"
        }
      ],
      fissionList: [
        {
          name: "企微好友裂变",
          value: "fission_person",
          bg:
            "https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img02.png",
          introduce: "通过完成任务获得奖励的方式，引导企业老客户邀请好友添加员工，快速拉新裂变。",  
        },
        {
          name: "企微群裂变",
          value: "fission_group",
          bg:
            "https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img02.png",
          introduce: "通过完成任务获得奖励的方式，引导企业老客户邀请新客加入群聊，实现群人数的快速增长。",  
        }
      ],
      LuckyCharmTypeList: [
        {
          name: "现场开奖",
          value: "scene",
          introduce: "在活动时间内参与报名，到时间后现场开奖或直播开奖",
        },
        {
          name: "普通开奖",
          value: "normal",
          introduce: "在活动参与时间内报名参与锦鲤抽奖，到中奖时间后公布中奖名单",
        },
        {
          name: "虚拟开奖",
          value: "virtualize",
          introduce: "在活动时间内参与报名，到时间后系统不会真实开奖，提示到其他位置领奖",
        },
      ],
      list: [
        {
          title: "大转盘",
          content: "幸运大抽奖，好礼抽不完",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/%E5%A4%A7%E8%BD%AC%E7%9B%98.png",
          bgimg:
            "https://imgcdn.hemiao100.com/decoration/ps5d47cd77f534d8d5-6e21-476f-98c5-61b4c05d3495.png",
          introduce: "点击开始转盘开始转动,最终指针指着的即为您所中的奖品",
          gameType: "WheelAct",
          activityFrom: "MyActivity",
          query: "turntable",
          show: true,
        },
        {
          title: "秒杀",
          content: "秒杀天天有，大家来抢购",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/%E7%A7%92%E6%9D%80.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/miaosha1.png",
          introduce:
            "在秒杀规定时间内选择商品并支付,支付成功后商家会根据收货地址发货",
          gameType: "SeckillAct",
          activityFrom: "MyActivity",
          query: "seckill",
          show: true,
        },
        {
          title: "砍价",
          content: "召集人马来砍价",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/%E7%A0%8D%E4%BB%B7.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/kanjia.png",
          introduce:
            "选择商品后进行砍价,自砍一刀后邀请好友帮忙看，砍到目标价格后即可领取奖品",
          gameType: "BargainAct",
          activityFrom: "MyActivity",
          query: "bargain",
          show: true,
        },
        {
          title: "拼团",
          content: "最爱拼团季，爱拼才会赢",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/groupBuying/ps9e7e66a912f01420-c130-4ffc-83e9-52bedd7d7b9e.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/tejiatuan.png",
          introduce:
            "选择商品，进行开团或参与拼团，提交订单成功后邀请好友拼团，达到人数即为拼团成功。",
          gameType: "SpecialAct",
          activityFrom: "MyActivity",
          query: "",
          show: true,
        },
        {
          title: "积分兑换",
          content: "积分兑换、好品多多",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jifen.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/jifenbg.png",
          introduce: "积分兑换、好品多多",
          gameType: "Redeem",
          activityFrom: "MyActivity",
          query: "integral_exchange",
          show: true,
        },
        {
          title: "单人单次专享活动",
          content: "单人单次专享礼",
          img: "https://imgcdn.hemiao100.com/ThemePictures/danrendanci.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/dangren.png",
          introduce:
            "在活动时间内选择商品购买并支付，每个活动里面的商品一个顾客只能购买其中一个，且只能购买一次。",
          gameType: "Single",
          activityFrom: "MyActivity",
          query: "single_single_exclusive",
          show: true,
        },
        {
          title: "预约活动",
          content: "预约活动",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps062521e7562ebf42-27fa-42a1-a86e-dd5db2da755e.png",
          bgimg:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps852f4b3b720537f9-57e5-4706-984c-35084e0c5cd6.png",
          introduce: "提前预约活动，活动开始即可根据报名地点前往参与线下活动",
          gameType: "AddEvent",
          activityFrom: "EventList",
          show: true,
        },
        {
          title: "锦鲤活动",
          content: "锦鲤活动",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jinlitip.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/jinlibg.png",
          introduce: "在活动时间内参与报名，到时间后现场开奖或直播开奖",
          gameType: "LuckyCharm",
          activityFrom: "MyActivity",
          query: "lucky_charm",
          show: true,
        },
        {
          title: "签到活动",
          content: "签到活动",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps6245e46007888f10-14b0-4f4a-b8fc-c1f87ddc7a86.png",
          bgimg:
            "https://imgcdn.hemiao100.com/hemiaoBase/psac64a64c79cb292c-7e59-454f-a9de-311417b098b0.png",
          introduce: "通过每日签到获得奖励",
          gameType: "AddSignInActivity",
          activityFrom: "SignInActivity",
          show: true,
        },
        {
          title: "抽奖活动",
          content: "抽奖活动",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/ps9ebc3164f54fbcbc-1978-46b5-89ba-afedcad8785b.png",
          bgimg:
            "https://imgcdn.hemiao100.com/hemiaoBase/psaab4935ad89b2f1f-a347-45cb-8789-a4ce6a38d2d6.png",
          introduce: "下单后即可兑换抽奖券，参与抽奖活动",
          gameType: "AddSweepstakes",
          activityFrom: "SweepstakesList",
          show: true,
        },
        {
          title: "集卡活动",
          content: "集卡活动",
          img:
            "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/ps612a3345d25f0cff-b95c-4d17-8ade-4fcd9116287b.png",
          bgimg: "https://imgcdn.hemiao100.com/hemiaoBase/actCenter/thumb.png",
          introduce: "参与集卡，赢取大奖励",
          gameType: "AddCollectCardAct",
          activityFrom: "MyActivity",
          query: "collect_card",
          show: true,
        },
        {
          title: "套餐活动",
          content: "套餐活动",
          img: "https://imgcdn.hemiao100.com/ThemePictures/taocanmini.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/55c4b3563ec8590924c30e7dab4fe07.png",
          introduce: "参与套餐活动，赢取大套餐",
          gameType: "AddPlanActivities",
          activityFrom: "MyActivity",
          query: "combination_set",
          show: true,
        },
        {
          title: "接龙活动",
          content: "接龙活动",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jielongmini.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/lALPD2eDP-EaGdjNCmz.jpg",
          introduce: "接龙活动",
          gameType: "JieLong",
          activityFrom: "JieLongActivite",
          query: "jielong",
          show: true,
        },
        {
          title: "助力劵活动",
          content: "助力券活动",
          img: "https://imgcdn.hemiao100.com/ThemePictures/zhulijuanbanner.png",
          bgimg:
              "https://imgcdn.hemiao100.com/ThemePictures/zhulijuanbg.png",
          introduce: "选择优惠券进行助力拼券，达到人数即助力成功",
          gameType: "AddHelpingAct",
          activityFrom: "MyActivity",
          query: "help_coupon",
          show: true,
        },
        {
          title: "省钱卡",
          content: "省钱卡",
          img: "https://imgcdn.hemiao100.com/mall/banner%40shenqiankasmall.png",
          bgimg:
                  "https://imgcdn.hemiao100.com/mall/saveMoneyCarBanner.png",
          introduce: "开通省钱卡，再购物，优惠更多",
          gameType: "AddSaveMoneyOnCard",
          activityFrom: "MyActivity",
          query: "save_money_card",
          show: true,
        },
        {
          title: "口令红包",
          content: "口令红包",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/passwordRedEnvelope/PasswordRedEnvelope_img01.png",
          bgimg:"https://imgcdn.hemiao100.com/hemiaoBase/passwordRedEnvelope/PasswordRedEnvelope_img02.png",
          introduce: "获取口令之后输入口令领取红包",
          gameType: "AddPasswordRedEnvelope",
          activityFrom: "MyActivity",
          query: "password",
          show: true,
        },
        {
          title: "红包雨",
          content: "红包雨",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img01.png",
          bgimg:"https://imgcdn.hemiao100.com/hemiaoBase/redEnvelopeRain/redEnvelopeRain_img02.png",
          introduce: "点击的越快次数越多，获得红包就越多，参加抽奖",
          gameType: "AddRedEnvelopeRain",
          activityFrom: "MyActivity",
          query: "red_envelope_rain",
          show: true,
        },
        {
          title: "企微裂变",
          content: "企微裂变",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img01.png",
          bgimg:"https://imgcdn.hemiao100.com/hemiaoBase/fission/fission_img02.png",
          introduce: "通过完成任务获得奖励的方式，引导企业老客户邀请好友添加员工，快速拉新裂变。",
          gameType: "Fission",
          activityFrom: "MyActivity",
          query: "fission",
          show: false,
        },
        {
          title: "定时抽奖",
          content: "定时抽奖",
          img: "https://imgcdn.hemiao100.com/hemiaoBase/timedDraw/preview.png",
          bgimg:"https://imgcdn.hemiao100.com/hemiaoBase/timedDraw/bgimg2.png",
          introduce: "定时抽奖",
          gameType: "TimedDraw",
          activityFrom: "MyActivity",
          query: "timed_draw",
          show:true,
        },
        // {
        //   title: "接龙活动",
        //   content: "接龙活动",
        //   img:
        //     "https://imgcdn.hemiao100.com/ThemePictures/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20210426175816.png",
        //   bgimg:
        //     "https://imgcdn.hemiao100.com/ThemePictures/55c4b3563ec8590924c30e7dab4fe07.png",
        //   introduce: "接龙活动",
        //   gameType: "JieLong",
        //   activityFrom: "MyActivity",
        //   query: "jielong"
        // }
      ],
      groupActList: [
        {
          title: "特价团",
          content: "你来我往，实惠共享",
          img: "https://imgcdn.hemiao100.com/ThemePictures/tejia.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/tejiatuan.png",
          introduce:
            "选择商品，进行开团或参与拼团，提交订单成功后邀请好友拼团，达到人数即为拼团成功。",
          gameType: "SpecialAct"
        },
        {
          title: "抽奖团",
          content: "拼到最后就有奖",
          img: "https://imgcdn.hemiao100.com/ThemePictures/choujiang.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/mianfeichang.png",
          introduce:
            "参与者可自行创建新团或加入他人创建的团，每个团满员后即有抽奖资格。活动结束后，商家将在后台从满员团中随机抽取一定数量的团中奖。",
          gameType: "LotteryAct"
        },
        {
          title: "团长免单团",
          content: "带头大哥坐享0元购",
          img: "https://imgcdn.hemiao100.com/ThemePictures/tuanzhang.png",
          bgimg:
            "https://imgcdn.hemiao100.com/ThemePictures/tuanzhangchang.png",
          introduce:
            "选择商品，进行开团或参与拼团，提交订单成功后邀请 好友拼团，达到人数即为拼团成功，团长可享受免单。",
          gameType: "LeaderFreeAct"
        },
        {
          title: "积分兑换",
          content: "积分兑换、好品多多",
          img: "https://imgcdn.hemiao100.com/ThemePictures/jifen.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/jifenbg.png",
          introduce: "积分兑换、好品多多",
          gameType: "Redeem"
        },
        {
          title: "单人单次专享活动",
          content: "单人单次专享礼",
          img: "https://imgcdn.hemiao100.com/ThemePictures/danrendanci.png",
          bgimg: "https://imgcdn.hemiao100.com/ThemePictures/dangren.png",
          introduce:
            "在活动时间内选择商品购买并支付，每个活动里面的商品一个顾客只能购买其中一个，且只能购买一次。",
          gameType: "Single"
        }
      ],
      row: {},
      storeCode: "",
      DialogVisibleNewIntegralExchange: false,
      activityList_02: "https://imgcdn.hemiao100.com/hemiaoBase/activity/activityList_02.png",
      newIntegralExchangeState: "close",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      showUploadImg: false,
      dialogVisibleGoodsSettingList: false,
      goodsSettingList: [],
      typeName: "",
      imgWidth: 0,
      imgHeight: 0,
      dialogVisibleGoodsSetting: false,
      integralType: "add",
      integralTypeTitle: "新增积分类型",
      integralTypeText: "新 增",
      storeCode: "",
      ruleFormType: {
        integralTypeName: "",
        previewImgPath: "",
        seqNum: "",
        indexpageShowState: "no",
      },
      rulesType: {
        integralTypeName: [
          {
            required: true,
            message: "请输入积分类型名称",
            trigger: "blur",
          },
        ],
        seqNum: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      },
      dialogVisibleRuleSetting: false, 
      ruleFormRule: {
        gameRuleRemark: "",
        gameRuleBg: "",
        gameRuleType: "newUrl",
        textContentZhCn: "",
      },
      textIdExplain: null,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.queryStoreConfigAll();
    this.queryGameTypeList();
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    async cropUploadSuccess(jsonData) {
      if (this.show) {
        this.groupIndexMainPic = jsonData.result;
        let params = {
          textCode: "groupBuyingMainPic",
          textContentZhCn: this.groupIndexMainPic,
          textName: "拼团首页主图",
          textType: "text",
          textId: this.textId || null
        };
        await this.$store.dispatch("addOrUpdate", params);
        this.$message({
          type: "success",
          message: "设置成功"
        });
        this.$forceUpdate();
      }
      if (this.uploadType === "previewImgPath") {
        this.ruleFormType.previewImgPath = jsonData.result;
      }
      if (this.uploadType === "gameRuleBg") {
        this.ruleFormRule.gameRuleBg = jsonData.result;
      }
    },
    toCreateActivity() {
      const route = { name: this.row.gameType };
      console.log("route:",route);
      switch (this.currentGameType) {
        case "WheelAct":
          Object.assign(route, {
            query: {
              wheelType: this.wheelType
            }
          });
          break;
        case "Fission":
          Object.assign(route, {
            query: {
              gameType: this.fissionType
            }
          });
          break;  
        case "LuckyCharm":
          Object.assign(route, {
            query: {
              styleType: this.styleType
            }
          });
          break;
        case "AddSweepstakes":
          Object.assign(route, {
            query: {
              type: "add"
            }
          });
          break;
          case "TimedDraw":
            Object.assign(route, {
              query: {
                styleType: this.styleType
              }
            });
            break;
        default:
          break;
      };

      console.log("route:",route);
      this.$router.push(route);
    },
    handleClick() {
      const v = this.groupActList.find(v => v.title === this.activeName);
      this.currentGameType = "SpecialAct";
      this.createdGame(v);
    },
    handleClickTurnTable() {
      const row = this.wheelTypeList.find(
        v => v.name === this.activeTurntableType
      );
      this.wheelType = row.value;
      this.bgimg = row.bg;
    },
    handleClickFission() {
      const row = this.fissionList.find(
        v => v.name === this.activeFissionType
      );
      this.fissionType = row.value;
      this.bgimg = row.bg;
      this.introduce = row.introduce;
    },
    handleClickLuckyCharm(){
      const row = this.LuckyCharmTypeList.find(
        v => v.name === this.activeLuckyCharm
      );
      this.styleType = row.value;
      this.introduce = row.introduce;
    },
    async createdGame(v) {
      switch (v.gameType) {
        case "SpecialAct":
        case "LotteryAct":
        case "LeaderFreeAct":
          this.currentGameType = "SpecialAct";
          break;
        default:
          this.currentGameType = v.gameType;
          break;
      }
      if(v.gameType === "SpecialAct"){
        const { result } = await this.$store.dispatch("queryByInfo", {
          textCode: "groupBuyingMainPic"
        });
        if (result && result.textContentZhCn) {
          this.groupIndexMainPic = result.textContentZhCn;
          this.textId = result.textId;
        }
      }
      this.row = v;
      this.title = v.title;
      this.introduce = v.introduce;
      if(v.gameType==="Redeem" && this.newIntegralExchangeState === "open"){
        this.bgimg = this.activityList_02;
      }else{
        this.bgimg = v.bgimg;
      }
      this.dialogVisible = true;
    },
    toMyActivity() {
      let query = null;
      let name = "";
      const row = this.list.find(v => v.gameType === this.currentGameType);
      if (row) {
        console.log("row---", row);
        name = row.activityFrom;
        if (row.activityFrom === "JieLongActivite") {
          name = "JieLongActivite";
          query = row.query;
        }
        if (this.currentGameType === "SpecialAct") {
          switch (this.row.gameType) {
            case "SpecialAct":
              query = "bargains_team";
              break;
            case "LotteryAct":
              query = "lottery_team";
              break;
            case "LeaderFreeAct":
              query = "leader_free_team";
              break;
            default:
              break;
          }
        } else {
          if (row.gameType === "Fission") {
            query = this.fissionType;
          }else{
            query = row.query;
          }
        }
      }

      this.$router.push({
        name,
        query: {
          gameType: query,
          newIntegralExchangeState: this.newIntegralExchangeState
        }
      });
    },
    addGoodsImg(v, type) {
      this.uploadType = type;
      switch (this.uploadType) {
        case "previewImgPath":
          this.imgWidth = 120;
          this.imgHeight = 120;
          break;
        case "gameRuleBg":
          this.imgWidth = 750;
          this.imgHeight = 450;
          break;  
      }
      this.currentGoods = v;
      this.showUploadImg = true;
    },
    handleRemovePrePic(type) {
      if (type === "previewImgPath") {
        this.ruleFormType.previewImgPath = "";
      }
      if (type === "gameRuleBg") {
        this.ruleFormRule.gameRuleBg = "";
      }
    },
    filterGt0OrFixed3(prop) {
      // this.ruleFormType[prop] = this.ruleFormType[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormType[prop] = this.ruleFormType[prop].replace(/[^\d]/g, ""); //仅保留数字和"."
      this.ruleFormType[prop] = this.ruleFormType[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleFormType[prop] = this.ruleFormType[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleFormType[prop]= this.ruleFormType[prop].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.ruleFormType[prop].indexOf(".") < 0 &&
        this.ruleFormType[prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleFormType[prop] = parseFloat(
          this.ruleFormType[prop]
        );
      }
    },
    openDialogNewIntegralExchange(){
      // this.DialogVisibleNewIntegralExchange = true;
      if(this.newIntegralExchangeState==="close"){
        this.DialogVisibleNewIntegralExchange = true;
        this.bgimg = this.activityList_02;
      }else{
        this.bgimg = "https://imgcdn.hemiao100.com/ThemePictures/jifenbg.png";
        this.newIntegralExchangeState = "close";
        
        this.editStoreConfigAll();
      }
    },
    closeDialogNewIntegralExchange(){
      this.DialogVisibleNewIntegralExchange = false;
    },
    confirmNewIntegralExchange(){
      this.newIntegralExchangeState = "open";
      this.editStoreConfigAll();
    },
    async queryStoreConfigAll(){
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code:"newIntegralExchange",
      });
      console.log("result:",result);
      if(result.value){
        this.newIntegralExchangeState = result.value;
      }else{
        this.addStoreConfigAll();
      }
    },
    async addStoreConfigAll(){
      const { result } = await this.$store.dispatch("addStoreConfigAll", {
        storeCode: this.storeCode,
        code:"newIntegralExchange",
        name:"新增体验新版积分商城",
        value: this.newIntegralExchangeState,
      });
      console.log("result:",result);
    },
    async editStoreConfigAll(){      
      const { result } = await this.$store.dispatch("editStoreConfigAll", {
        storeCode: this.storeCode,
        code:"newIntegralExchange",
        name:"编辑体验新版积分商城",
        value: this.newIntegralExchangeState,
      });
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.queryStoreConfigAll();
      this.DialogVisibleNewIntegralExchange = false;
    },    
    openGoodsSetting() {
      this.dialogVisibleGoodsSettingList = true;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    addGoodsSetting() {
      this.integralType = "add";
      this.integralTypeText = "新 增";
      this.integralTypeTitle = "新增积分类型";
      this.ruleFormType = {
        integralTypeName: "",
        previewImgPath: "",
        seqNum: "",
        indexpageShowState: "no",
      };
      this.dialogVisibleGoodsSetting = true;
    },
    async editGoods(row) {
      this.integralType = "edit";
      this.integralTypeText = "保 存";
      this.integralTypeTitle = "编辑积分类型";
      let params = {
        id: row.id,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoQueryById",
        params
      );
      this.ruleFormType = result;
      this.dialogVisibleGoodsSetting = true;
    },
    async removeGoods(row) {
      let params = {
        id: row.id,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoQueryById",
        params
      );
      console.log("result:", result);
      if (result) {
        if (result.useCount > 0) {
            let useCount = result.useCount;
            const result2 = await this.$confirm("此类型已绑定"+ useCount +"个商品,是否删除本条数据?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
            if (result2 === "confirm") {
              this.deleteGoods(row);
            }
        }else{
          this.deleteGoods(row);
        }
      }
    },
    async deleteGoods(row) {
      let params = {
        id: row.id,
      };
      const { code } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoDelete",
        params
      );
      if (code === "0") {
        this.queryWxshopSpuIntegralTypeInfoList();
      }
    },
    save() {
      this.dialogVisibleGoodsSettingList = false;
    },
    close() {
      this.dialogVisibleGoodsSettingList = false;
    },
    saveRuleFormType(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.ruleFormType.indexpageShowState === "yes" &&
            !this.ruleFormType.previewImgPath
          ) {
            this.$message({
              message: "如果在首页展示,请先上传预览图",
              type: "warning",
            });
            return;
          }
          let params = JSON.parse(JSON.stringify(this.ruleFormType));
          let url;
          if (this.integralType === "add") {
            url = "wxshopSpuIntegralTypeInfoAdd";
          } else if (this.integralType === "edit") {
            url = "wxshopSpuIntegralTypeInfoEdit";
          }
          this.$store.dispatch(url, params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisibleGoodsSetting = false;
              this.queryWxshopSpuIntegralTypeInfoList();
            }
          });
        }
      });
    },
    closeRuleFormType() {
      this.dialogVisibleGoodsSetting = false;
    },
    async queryWxshopSpuIntegralTypeInfoList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      };
      const { result } = await this.$store.dispatch(
        "wxshopSpuIntegralTypeInfoList",
        params
      );
      const { records, total } = result;
      this.goodsSettingList = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryWxshopSpuIntegralTypeInfoList();
    },
    async openRuleSetting() {
      this.dialogVisibleRuleSetting = true;
      // 查询规则设置
      const { result } = await this.$store.dispatch("queryByInfo", {
        textCode: "newIntegralExchangeRuleSetting"
      });
      if (result && result.textContentZhCn) {
        this.ruleFormRule.gameRuleBg = result.textImgZhCn || "" ;
        this.ruleFormRule.gameRuleType = result.textType || "";
        this.ruleFormRule.gameRuleRemark = result.textContentZhCn;
        this.textId = result.textId;
      }
      // 查询规则内容说明
      const { result: resultExplain } = await this.$store.dispatch("queryByInfo", {
        textCode: "newIntegralExchangeRuleExplain"
      });
      if (resultExplain && resultExplain.textContentZhCn) {
        this.ruleFormRule.textContentZhCn = resultExplain.textContentZhCn;
        this.textIdExplain = resultExplain.textId;
      }
    },
    async saveRule(){
      // 保存规则设置
      let params = {
        textCode: "newIntegralExchangeRuleSetting",
        textContentZhCn: this.ruleFormRule.gameRuleRemark,
        textImgZhCn: this.ruleFormRule.gameRuleBg,
        textName: "新版积分商城规则设置",
        textType: this.ruleFormRule.gameRuleType,
        textId: this.textId || null
      };
      await this.$store.dispatch("addOrUpdate", params);
      // 保存规则内容说明
      let paramsExplain = {
        textCode: "newIntegralExchangeRuleExplain",
        textContentZhCn: this.ruleFormRule.textContentZhCn,
        textName: "新版积分商城规则内容说明",
        textId: this.textIdExplain || null
      };
      await this.$store.dispatch("addOrUpdate", paramsExplain);
      this.$message({
        type: "success",
        message: "设置成功"
      });
      this.$forceUpdate();
      this.dialogVisibleRuleSetting = false;
    },
    closeRule(){
      this.dialogVisibleRuleSetting = false;
    },
    async queryGameTypeList() {
      const { result } = await this.$store.dispatch("queryGameTypeList");
      if(result){
        result.forEach(v => {
          if(v.gameCode === 'fission_person' || v.gameCode === 'fission_group'){
            this.list.forEach(o=>{
              if(o.gameType === 'Fission'){
                o.show = true;
              }
            })
          }
        });
      }
    },
  }
};
</script>
<style lang="scss">
.elTab {
  .el-tabs__nav-scroll {
    display: flex !important;
    display: -webkit-flex !important;
    justify-content: center;
    -webkit-justify-content: center;
  }
  .mr10 {
    margin-right: 0 !important;
  }
  .el-tabs__nav-wrap::after {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
.bo {
  .time {
    font-size: 13px;
    color: #999;
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }
}
.grid-content {
  width: 250px;
  border-radius: 4px;
  margin: 10px;
  padding: 10px;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
  position: relative;
  margin-right:20px;
  // .add-wrapper {
  //   position: absolute;
  //   right: 0;
  //   top: 103px;
  // }
}
.acttitle {
  line-height: 24px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.gameImg {
  width: 200px;
  // height: 550px;
}
.introduce {
  padding: 0 50px 0;
  // margin-left: 100px;
  // margin-top: 55px;
  p {
    font-size: 14px;
    line-height: 30px;
    font-weight: 900;
  }
}

.create {
  width: 100%;
  height: 200px;
  margin-bottom: 30px;
  img {
    width: 100%;
    height: 200px;
  }
}

.priview {
  position: relative;
  width: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.newIntegralExchange{
  font-size: 16px;
  font-weight: blod;
  color: #222222;
  line-height: 19px;
}
.newIntegralExchangeContent{
  .img{
    width: 360px;
    display: block;
  }
  .right{
    padding-left: 50px;
    .h2{
      padding-top: 40px;
      font-size: 25px;
      color: #222222;
      line-height: 30px;
      padding-bottom: 14px;
    }
    .h3{
      font-size: 16px;
      color: #222222;
      line-height: 19px;
      padding: 5px 0;
    }
  }
}
.goodsSetting {
  line-height: 40px;
  border-bottom: 1px solid #dddddd;
  .form-gray {
    color: #aaaaaa;
  }
}
.preview-type-list {
  width: 100%;
  .type-title {
    text-indent: 10px;
    line-height: 32px;
  }
  .type-item {
    display: inline-block;
    width: 166px;
    height: 83px;
    margin: 6px;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  text-align: center;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 0;
  padding: 0;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviews2 {
  width: 170px;
}
</style>
